import ContentTypeHelper from '~/util/content-type/ContentTypeHelper';
import { MigrateRequest } from './Operations';
import ContensisRepository from '~/repositories/ContensisRepository';

export interface IContensisContext extends ContentTypeHelper {
  payload: MigrateRequest;
  source: ContensisRepository;
}
